import { get } from 'lodash'

export default function(fields = {}) {
  const transportationModes = get(fields, 'transportationModes')

  const transportationModeList = transportationModes && transportationModes.map(item => {
    return {
      id: get(item, 'transportationMode.id'),
      value: get(item, 'transportationMode.modeOfTransportType.value'),
      label: get(item, 'transportationMode.modeOfTransportType.translationText')
    }
  })

  return {
    ...fields,
    transportationModes: transportationModeList
  }
}
